'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Clock, Radio, Monitor, Globe, Lock, Users } from 'lucide-react';
import { motion } from 'motion/react';
import { featuresBottomCtaLabel } from '@/lib/invite-only';
const FEATURES = [{
  title: 'Pre-Build Sequences',
  icon: Clock,
  copy: 'Organize media by shots/scenes: images, videos, text, simple interactives like fake chats or calls.',
  className: 'md:col-span-2'
}, {
  title: 'Real-Time Triggers',
  icon: Radio,
  copy: 'One-tap control from your admin device—broadcast to all viewers with sub-second precision.',
  className: ''
}, {
  title: 'No-Account Viewers',
  icon: Monitor,
  copy: 'Share a public URL; devices connect instantly, pre-download assets for reliability.',
  className: ''
}, {
  title: 'Browser Everywhere',
  icon: Globe,
  copy: 'Works on phones, tablets, laptops, TVs via any modern browser. Fullscreen mode for immersive props.',
  className: 'md:col-span-2'
}, {
  title: 'Secure Admin Access',
  icon: Lock,
  copy: 'Password-protected accounts for creators; viewers are read-only.',
  className: ''
}, {
  title: 'Scalable for Any Shoot',
  icon: Users,
  copy: 'Handle indie shorts or big-budget scenes—one admin, infinite viewers.',
  className: 'md:col-span-2'
}] as const;
export function Features() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <motion.h2 id="features-heading" initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="font-heading text-center text-3xl font-bold text-white md:text-4xl">Precision Tools for Production Chaos</motion.h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-12 grid gap-4 sm:mt-16 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">{FEATURES.map(_temp)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    t3 = {
      opacity: 1
    };
    t4 = {
      once: true
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section id="features" className="scroll-mt-20 border-t border-[var(--landing-border)] px-4 py-24 md:py-28" aria-labelledby="features-heading"><div className="mx-auto max-w-6xl">{t0}{t1}<motion.div initial={t2} whileInView={t3} viewport={t4} className="mt-12 text-center sm:mt-16"><Link href="/signup" className="inline-flex h-11 items-center justify-center rounded-xl bg-[var(--landing-accent-red)] px-8 text-sm font-semibold text-white shadow-[0_0_24px_-4px_rgba(255,77,77,0.3)] transition hover:opacity-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--landing-accent-red)] focus-visible:ring-offset-2 focus-visible:ring-offset-black">{featuresBottomCtaLabel()}</Link></motion.div></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp(feature) {
  const Icon = feature.icon;
  return <motion.article key={feature.title} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-40px"
  }} transition={{
    duration: 0.35,
    ease: "easeOut"
  }} className={`group flex flex-col rounded-2xl border border-[var(--landing-border)] bg-white/[0.04] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[var(--landing-accent-blue)]/40 hover:bg-white/[0.07] hover:shadow-[0_0_32px_-8px_rgba(0,191,255,0.2)] lg:p-8 ${feature.className}`}><div className="text-[var(--landing-accent-blue)] transition-transform duration-300 group-hover:scale-110"><Icon className="h-9 w-9" aria-hidden={true} /></div><h3 className="mt-4 font-heading text-xl font-semibold text-white lg:text-2xl">{feature.title}</h3><p className="mt-2 flex-1 text-[var(--landing-muted)] leading-relaxed">{feature.copy}</p></motion.article>;
}